import { cn } from '@ooh/ui/lib/utils';

interface PublishRequiredHintProps {
  message: string;
  testId: string;
  className?: string;
}

/**
 * Shared amber inline hint shown when an action (generate link, open preview) is
 * gated on the offer having a published version. Extracted so PublicLinkControls
 * and ClientShareDialogBody don't each hand-roll the same markup (CU-86cak25ct).
 */
export function PublishRequiredHint({ message, testId, className }: PublishRequiredHintProps) {
  return (
    <p
      className={cn(
        'flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800',
        className,
      )}
      data-testid={testId}
    >
      {message}
    </p>
  );
}
